export default __webpack_public_path__ + "static/media/treeVector.3a69e224.svg";